import React from 'react';
import Home from '../components/Home';

const HomePage = () => {
  return (
    <div className="container">
      <div className="page-section animate-fade-in-up animate-stagger">
        <Home />
      </div>
    </div>
  );
};

export default HomePage;
